import React from 'react';
import {Motion, spring} from 'react-motion';

import PropTypes from 'prop-types';

import {describeArc, describeRadialLineSegment} from '../../../../../../util/svg-drawing';

import styles from './fuel-gauge.module.css';

const GAUGE_RADIUS = 150;
const GAUGE_WIDTH = 15;
const TODAY_LINE_EXTENSION = 5;
const ORIGIN = {
    x: GAUGE_RADIUS + GAUGE_WIDTH - TODAY_LINE_EXTENSION / 2,
    y: GAUGE_RADIUS + GAUGE_WIDTH - TODAY_LINE_EXTENSION,
};

FuelGauge.propTypes = {
    hasQuota: PropTypes.bool,
    percentComplete: PropTypes.number,
    currentPercentToEndTime: PropTypes.number,
};
export function FuelGauge(props) {
    const totalHeight = GAUGE_RADIUS + GAUGE_WIDTH / 2 + TODAY_LINE_EXTENSION;
    const viewBox = [0, 0, 2 * totalHeight, totalHeight].join(' ');

    return (
        <div className={styles['fuel-gauge-container']}>
            <div className={styles['svg-container']}>
                <svg height={180} viewBox={viewBox} key='gauge'>
                    {renderGaugeContainer(props.hasQuota)}
                    {props.hasQuota
                        ? renderCurrentStatus(props.percentComplete, props.currentPercentToEndTime)
                        : undefined}
                    {props.hasQuota
                        ? renderCurrentTimeLine(props.currentPercentToEndTime)
                        : undefined}
                </svg>
            </div>
        </div>
    );
}

function renderGaugeContainer(hasQuota) {
    if (hasQuota) {
        return (
            <path
                d={describeArc(ORIGIN, GAUGE_RADIUS, {start: 0, end: 180})}
                strokeWidth={GAUGE_WIDTH}
                className={styles['arc-background']}
            />
        );
    }

    return [
        <path
            key='inner-arc'
            d={describeArc(ORIGIN, GAUGE_RADIUS - GAUGE_WIDTH / 2, {start: 0, end: 180})}
            className={styles['arc-outline']}
        />,
        <path
            key='outer-arc'
            d={describeArc(ORIGIN, GAUGE_RADIUS + GAUGE_WIDTH / 2, {start: 0, end: 180})}
            className={styles['arc-outline']}
        />,
        <path
            key='0-line'
            d={describeRadialLineSegment(
                ORIGIN,
                {inner: GAUGE_RADIUS - GAUGE_WIDTH / 2, outer: GAUGE_RADIUS + GAUGE_WIDTH / 2},
                0
            )}
            className={styles['arc-outline']}
        />,
        <path
            key='180-line'
            d={describeRadialLineSegment(
                ORIGIN,
                {inner: GAUGE_RADIUS - GAUGE_WIDTH / 2, outer: GAUGE_RADIUS + GAUGE_WIDTH / 2},
                180
            )}
            className={styles['arc-outline']}
        />,
    ];
}

function renderCurrentTimeLine(currentPercentToEndTime) {
    const todayLineLowerExtension = 1; // To fully cover arc stroke

    return [
        <path
            key='today-line-background'
            d={describeRadialLineSegment(
                ORIGIN,
                {
                    inner: GAUGE_RADIUS - GAUGE_WIDTH / 2 - todayLineLowerExtension,
                    outer: GAUGE_RADIUS + GAUGE_WIDTH / 2 + TODAY_LINE_EXTENSION,
                },
                currentPercentToEndTime * 180
            )}
            stroke='white'
            strokeWidth={7}
            fill='none'
        />,
        <path
            key='today-line'
            d={describeRadialLineSegment(
                ORIGIN,
                {
                    inner: GAUGE_RADIUS - GAUGE_WIDTH / 2 - todayLineLowerExtension,
                    outer: GAUGE_RADIUS + GAUGE_WIDTH / 2 + TODAY_LINE_EXTENSION,
                },
                currentPercentToEndTime * 180
            )}
            stroke='#45423e'
            strokeWidth={3}
            fill='none'
        />,
    ];
}

function renderCurrentStatus(percentComplete, currentPercentToEndTime) {
    const statusColor = percentComplete > currentPercentToEndTime ? '#1fb790' : '#fa4a62';
    const percentAngle = Math.min(percentComplete * 180, 180);

    return (
        <Motion style={{x: spring(percentAngle)}}>
            {(interpolatedStyle) => {
                return (
                    <path
                        d={describeArc(ORIGIN, GAUGE_RADIUS, {start: 0, end: interpolatedStyle.x})}
                        stroke={statusColor}
                        strokeWidth={GAUGE_WIDTH}
                        className={styles.arc}
                    />
                );
            }}
        </Motion>
    );
}
